import { LearningItem } from '../../models/LearningItem'
import bookingForLearningItem from './bookingForLearningItem'
import learningItemTimeInvested from './learningItemTimeInvested'

export default function learningInvestmentFunnel(userLearningItems: LearningItem[]) {
  return {
    inLibrary: userLearningItems.filter((item) => bookingForLearningItem(item) || item.userLearningAssignments?.length)
      .length,
    started: userLearningItems.filter(
      (item) => learningItemTimeInvested(item) > 0 || item.learningProgress?.completedAt
    ).length,
    finished: userLearningItems.filter((item) => item.learningProgress?.completedAt).length,
  }
}
